import { Component, EventEmitter, HostBinding, Input, OnDestroy, Optional, Output, Self } from '@angular/core';
import { LoggerFactory } from '@elderbyte/ts-logger';
import { Subject } from 'rxjs';
import { NgControl } from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';

@Component({
  selector: 'tcc-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent implements OnDestroy, MatFormFieldControl<string> {

  private static _logger = LoggerFactory.getLogger('FileInputComponent');

  private static nextId = 0;

  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() filter = 'application/zip,application/x-zip-compressed';

  @Output() fileSelect = new EventEmitter<File>();

  // MatFormFieldControl implementation
  @HostBinding() id = `tcc-file-input-${FileInputComponent.nextId++}`;
  readonly controlType = 'tcc-file-input';
  readonly focused = false;
  @Input() required: boolean;
  readonly shouldLabelFloat = false;
  readonly stateChanges = new Subject<void>();
  value: string | null;


  constructor(
    @Optional() @Self() public ngControl: NgControl,
  ) { }


  ngOnDestroy() {
    this.stateChanges.complete();
  }


  onFileChange(fileInput: any) {
    // No file selected
    if (!fileInput.target.files || !fileInput.target.files[0]) {
      FileInputComponent._logger.debug('No file selected');
      return;
    }

    this.value = fileInput.target.files[0].name;
    this.stateChanges.next();

    this.fileSelect.emit(fileInput.target.files[0]);
  }


  // MatFormFieldControl implementation

  onContainerClick(event: MouseEvent): void {
  }

  setDescribedByIds(ids: string[]): void {
  }


  get errorState() {
    return !this.value;
  }

  get empty() {
    return !this.value;
  }

}
